import TopbarContainer from 'views/molecules/topbar/TopbarContainer';

export default TopbarContainer;
